var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37162 7.26396C4.39646 7.01656 4.30284 6.77204 4.11951 6.60553L2.2521 4.33862V4H8.05042L12.5322 13.9048L16.4725 4H22V4.33862L20.4034 5.88125C20.2657 5.98698 20.1974 6.16075 20.226 6.33275V17.6673C20.1974 17.8392 20.2657 18.013 20.4034 18.1188L21.9627 19.6614V20H14.1195V19.6614L15.7348 18.0811C15.8936 17.9212 15.8936 17.8742 15.8936 17.6296V8.46796L11.4024 19.9624H10.7955L5.56676 8.46796V16.1717C5.52316 16.4955 5.62991 16.8216 5.85621 17.0559L7.95705 19.6238V19.9624H2V19.6238L4.10084 17.0559C4.32549 16.8212 4.42601 16.493 4.37162 16.1717V7.26396Z",
    fill: "#B5BEED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedium);
export default __webpack_public_path__ + "static/media/social-medium.66d55e4b3d5bf1a9add401026c1fbea7.svg";
export { ForwardRef as ReactComponent };